import { TypePolicies } from '@apollo/client';
import { CapaQuotationUserRfqsOutput } from '@generated/graphql';

const fetchQuotationUserRfqsCache: TypePolicies = {
  Query: {
    fields: {
      fetchQuotationUserRfqs: {
        keyArgs: ['input', ['searchKeyword', 'searchType']],
        merge: (
          exsiting: CapaQuotationUserRfqsOutput,
          incoming: CapaQuotationUserRfqsOutput,
          {
            args: {
              input: { offset }
            }
          }: any
        ) => {
          if (!exsiting) return incoming;

          const incomingRfqs = incoming.data?.rfqs ?? [];
          const merged = exsiting.data?.rfqs
            ? exsiting.data?.rfqs.slice(0)
            : [];

          for (let i = 0; i < incomingRfqs.length; ++i) {
            merged[offset + i] = incomingRfqs[i];
          }

          return {
            __typename: 'CAPAQuotationUserRfqsOutput',
            ...incoming,
            data: {
              ...incoming.data,
              rfqs: merged
            }
          };
        }
      }
    }
  }
};

export default fetchQuotationUserRfqsCache;
